import React from "react"
import { useTranslation } from "react-i18next"

import { z } from "zod"

export const useConfigureValidationTranslation = () => {
  const { t } = useTranslation()

  React.useEffect(() => {
    z.config({
      customError: (issue) => {
        // Array
        if (issue.origin === "array") {
          // Min
          if (issue.code === "too_small" && issue.minimum === 1) {
            return t("validation.arrayMin")
          }
        }

        // Boolean
        if (issue.origin === "boolean") {
          // Required
          if (issue.code === "too_small" && issue.minimum === 1) {
            return t("validation.required")
          }
        }

        // Confirm password
        if (issue.origin === "confirm_password") {
          // Match
          if (issue.code === "custom") {
            return t("validation.passwordMatch")
          }
        }

        // Edit site address custom validation
        if (issue.code === "custom") {
          if (
            issue.origin === "address_city_required" ||
            issue.origin === "address_country_required"
          ) {
            return t("validation.required")
          }
          if (issue.origin === "address_country_invalid_length") {
            return t("editSite.invalidCountryCodeError")
          }
          if (issue.origin === "address_invalid_us_state") {
            return t("editSite.invalidUSStateError")
          }
          if (issue.origin === "invalid_end_date") {
            return t("validation.invalidEndDate")
          }
        }

        // Email
        if (issue.format === "email") {
          // Format
          if (issue.code === "invalid_format") {
            return t("validation.email")
          }
        }

        // Date
        if (issue.format === "date") {
          // Format
          if (issue.code === "invalid_format") {
            return t("validation.date")
          }
        }

        // URL
        if (issue.format === "url") {
          // Format
          if (issue.code === "invalid_format") {
            return t("validation.invalidUrl")
          }
        }

        // Number
        if (issue.origin === "number") {
          // Required
          if (issue.code === "too_small" && issue.minimum === 1) {
            return t("validation.required")
          }

          // Max
          if (issue.code === "too_big") {
            return t("validation.numberMax", { max: issue.maximum })
          }

          // Min
          if (issue.code === "too_small" && issue.origin === "number") {
            return t("validation.numberMin", { min: issue.minimum })
          }
        }

        // Number type
        if (issue.code === "invalid_type" && issue.expected === "number") {
          return t("validation.numberInvalid")
        }

        // String
        if (issue.origin === "string") {
          // Required
          if (issue.code === "too_small" && issue.minimum === 1) {
            return t("validation.required")
          }

          // Max
          if (issue.code === "too_big") {
            return t("validation.stringMax", { max: issue.maximum })
          }

          // Min
          if (issue.code === "too_small" && issue.minimum > 1) {
            return t("validation.stringMin", { min: issue.minimum })
          }
        }

        // Default
        return ""
      },
    })
  }, [t])
}
